module.exports = __webpack_public_path__ + "static/image-partenaire-4156c9b70321bbbe29c087174ea99813.png";